import request from "@/shared/apis";

const BASE = "scheduling-profiles";

const schedulingProfiles = {
  create: (dto) => request.post(BASE, dto),
  update: (id, dto) => request.put(`${BASE}/${id}`, dto),
  get: (id) => request.get(`${BASE}/${id}`),
  list: (params = {}) =>
    request.get(params.purpose ? `${BASE}?purpose=${params.purpose}` : BASE),
  remove: (id) => request.delete(`${BASE}/${id}`),
};

export default schedulingProfiles;
